import { DatePicker, Row, Col, Form, Button, Space } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Text } from 'atoms';

export function DateRangePicker({
	scope,
	dateset,
	setdate,
	updatefn,
	qfilt = true,
	clearAllFilters,
	areFiltersApplied,
}) {
	const checkStartDate = dateset.endDate.clone().subtract(scope, 'days');
	const checkEndDate = dateset.startDate.clone().add(scope, 'days');
	return (
		<Form layout="horizontal">
			<Row gutter={10} align="top">
				<Col>
					<Row align="middle">
						<Space>
							<Text>From:</Text>
							<DatePicker
								placeholder="From"
								format="DD-MMM-yyyy"
								disabledDate={(current) =>
									current < checkStartDate || current > dateset.endDate
								}
								onChange={(value) => {
									const newDateRange = { ...dateset, startDate: value };
									setdate(newDateRange);
									// Auto-apply filter when date changes
									if (value && dateset.endDate) {
										updatefn(false, newDateRange); // Pass the new date range
									}
								}}
								defaultValue={dateset.startDate}
								value={qfilt && dateset.startDate}
								allowClear={false}
							/>
						</Space>
					</Row>
				</Col>
				<Col>
					<Row align="middle">
						<Space>
							<Text>To:</Text>
							<DatePicker
								placeholder="To"
								format="DD-MMM-yyyy"
								disabledDate={(current) =>
									current > checkEndDate ||
									current > moment().add(1, 'day') ||
									current < dateset.startDate
								}
								defaultValue={dateset.endDate}
								onChange={(value) => {
									const newDateRange = { ...dateset, endDate: value };
									setdate(newDateRange);
									// Auto-apply filter when date changes
									if (value && dateset.startDate) {
										updatefn(false, newDateRange); // Pass the new date range
									}
								}}
								value={qfilt && dateset.endDate}
								allowClear={false}
							/>
						</Space>
					</Row>
				</Col>
				<Col></Col>
				<Col>
					<Row align="middle">
						<Space>
							{areFiltersApplied && (
								<Button
									style={{ width: '35px', height: '35px' }}
									type="primary"
									danger
									icon={<CloseOutlined />}
									onClick={() => {
										clearAllFilters();
									}}
									title="Remove filters"
								/>
							)}
						</Space>
					</Row>
				</Col>
			</Row>
		</Form>
	);
}

DateRangePicker.propTypes = {
	scope: PropTypes.number,
	dateset: PropTypes.object,
	setdate: PropTypes.func,
	updatefn: PropTypes.func,
	qfilt: PropTypes.bool,
	clearAllFilters: PropTypes.func,
	areFiltersApplied: PropTypes.bool,
};
